import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;
const ClubManagement = () => {

const [showGameFeeModal, setShowGameFeeModal] = useState(false);
    const table1 = useRef(null);
    const table2 = useRef(null);

    useEffect(() => {
    window.JSZip = jszip;

    let table11, table12;

    if (table1.current) {
        table11 = $(table1.current).DataTable({
            pageLength: 5,
            lengthChange: false,
            ordering: true,
            destroy: true,
            dom:
                "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
            buttons: [
                { extend: "copy", text: "Copy" },
                { extend: "excel", text: "Excel" },
                { extend: "pdf", text: "PDF" },
                { extend: "print", text: "Print" },
            ],
        });
    }

    if (table2.current) {
        table12 = $(table2.current).DataTable({
            pageLength: 5,
            lengthChange: false,
            ordering: true,
            destroy: true,
            dom:
                "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
            buttons: [
                { extend: "copy", text: "Copy" },
                { extend: "excel", text: "Excel" },
                { extend: "pdf", text: "PDF" },
                { extend: "print", text: "Print" },
            ],
        });
    }

    return () => {
        if (table11) table11.destroy();
        if (table12) table12.destroy();
    };
}, []);

const openGameFeeModal = () => {
    setShowGameFeeModal(true);
};

const closeGameFeeModal = () => {
    setShowGameFeeModal(false);
};
    return (
        <>
            <div className="page-wrapper">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Finances & Payouts</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Finances & Payouts</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                        <div className="row g-4 mb-4">
                            <div className="col-md-3">
                                <div className="summary-card">
                                    <div className="summary-icon" style={{ background: '#e1f0fa', color: '#0d6efd' }}>
                                        <i className="bx bx-dollar-circle" />
                                    </div>
                                    <div className="summary-label">Total Game Fees Received</div>
                                    <div className="summary-value">$12,450</div>
                                    <div className="summary-sub">↑ 8% from last season</div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card">
                                    <div className="summary-icon" style={{ background: '#fff3cd', color: '#997404' }}>
                                        <i className="bx bx-time" />
                                    </div>
                                    <div className="summary-label">Pending Game Fees</div>
                                    <div className="summary-value">$3,200</div>
                                    <div className="summary-sub">5 invoices pending</div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card">
                                    <div className="summary-icon" style={{ background: '#e1f7e1', color: '#1e7e34' }}>
                                        <i className="bx bx-wallet" />
                                    </div>
                                    <div className="summary-label">Total Referee Payouts</div>
                                    <div className="summary-value">$8,750</div>
                                    <div className="summary-sub">24 games completed</div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card">
                                    <div className="summary-icon" style={{ background: '#e9ecef', color: '#495057' }}>
                                        <i className="bx bx-calculator" />
                                    </div>
                                    <div className="summary-label">Total Commission</div>
                                    <div className="summary-value">$1,245</div>
                                    <div className="summary-sub">10% of game fees</div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <ul className="nav nav-tabs mb-4" id="financeTabs" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="game-fees-tab" data-bs-toggle="tab" data-bs-target="#game-fees" type="button" role="tab">Game Fees</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="referee-fees-tab" data-bs-toggle="tab" data-bs-target="#referee-fees" type="button" role="tab">Referee Fees</button>
                                    </li>
                                </ul>
                                <div className="tab-content" id="financeTabsContent">
                                    {/* GAME FEES TAB */}
                                    <div className="tab-pane fade show active" id="game-fees" role="tabpanel">
                                        {/* Sub-tabs */}
                                        <div className="sub-tabs">
                                            <button className="btn active" onclick="filterGameFees('all')">All</button>
                                            <button className="btn" onclick="filterGameFees('pending')">Pending Payment</button>
                                            <button className="btn" onclick="filterGameFees('received')">Received</button>
                                            <button className="btn" onclick="filterGameFees('overdue')">Overdue</button>
                                        </div>
                                        {/* Filters */}
                                        <div className="filters-row">
                                            <div className="row g-3">
                                                <div className="col-md-3">
                                                    <label className="form-label">Season</label>
                                                    <select className="form-select">
                                                        <option>All Seasons</option>
                                                        <option>Spring 2026</option>
                                                        <option>Fall 2025</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-3">
                                                    <label className="form-label">Club Director</label>
                                                    <input type="text" className="form-control" placeholder="Search by name" />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label">Date Range</label>
                                                    <div className="d-flex gap-2">
                                                        <input type="date" className="form-control" placeholder="From" />
                                                        <input type="date" className="form-control" placeholder="To" />
                                                    </div>
                                                </div>
                                                <div className="col-md-2 d-flex align-items-end">
                                                    <button className="btn btn-primary w-100">Apply</button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Export buttons */}
                                        <div className="entries-wrapper mb-3 tabs-entress">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        {/* Game Fees Table */}
                                        <table className="table table-striped table-bordered f-table" id="table1" ref={table1}>
                                            <thead>
                                                <tr>
                                                    <th>Invoice ID</th>
                                                    <th>Club Director</th>
                                                    <th>Club Name</th>
                                                    <th>Team</th>
                                                    <th>Game ID</th>
                                                    <th>Season</th>
                                                    <th>Fee Amount</th>
                                                    <th>Due Date</th>
                                                    <th>Payment Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>INV-001</td>
                                                    <td>Robert Johnson</td>
                                                    <td>Tigers FC</td>
                                                    <td>Tigers U-10</td>
                                                    <td>GM-001</td>
                                                    <td>Spring 2026</td>
                                                    <td>$500</td>
                                                    <td>Feb 20, 2026</td>
                                                    <td><span className="badge bg-soft-success">Received</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameFeeModal}><i className="lni lni-eye" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>INV-002</td>
                                                    <td>Sarah Williams</td>
                                                    <td>Panthers CC</td>
                                                    <td>Panthers U-10</td>
                                                    <td>GM-002</td>
                                                    <td>Spring 2026</td>
                                                    <td>$500</td>
                                                    <td>Feb 22, 2026</td>
                                                    <td><span className="badge bg-soft-warning">Pending</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameFeeModal}><i className="lni lni-eye" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>INV-003</td>
                                                    <td>Michael Smith</td>
                                                    <td>Wolves FC</td>
                                                    <td>Wolves U-14</td>
                                                    <td>GM-003</td>
                                                    <td>Spring 2026</td>
                                                    <td>$600</td>
                                                    <td>Feb 18, 2026</td>
                                                    <td><span className="badge bg-soft-danger">Overdue</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameFeeModal}><i className="lni lni-eye" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>INV-004</td>
                                                    <td>Alex Morgan</td>
                                                    <td>Riverside FC</td>
                                                    <td>Eagles U10</td>
                                                    <td>GM-004</td>
                                                    <td>Spring 2026</td>
                                                    <td>$500</td>
                                                    <td>Feb 25, 2026</td>
                                                    <td><span className="badge bg-soft-success">Received</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameFeeModal}><i className="lni lni-eye" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>INV-005</td>
                                                    <td>David Kim</td>
                                                    <td>North Stars SC</td>
                                                    <td>Rockets U10</td>
                                                    <td>GM-005</td>
                                                    <td>Spring 2026</td>
                                                    <td>$500</td>
                                                    <td>Feb 28, 2026</td>
                                                    <td><span className="badge bg-soft-warning">Pending</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap">
                                                            <li><a href="#" onClick={openGameFeeModal}><i className="lni lni-eye" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* REFEREE FEES TAB */}
                                    <div className="tab-pane fade" id="referee-fees" role="tabpanel">
                                        {/* Filters */}
                                        <div className="filters-row">
                                            <div className="row g-3">
                                                <div className="col-md-2">
                                                    <label className="form-label">Season</label>
                                                    <select className="form-select">
                                                        <option>All Seasons</option>
                                                        <option>Spring 2026</option>
                                                        <option>Fall 2025</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-3">
                                                    <label className="form-label">Referee Name</label>
                                                    <input type="text" className="form-control" placeholder="Search referee" />
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label">Game ID</label>
                                                    <input type="text" className="form-control" placeholder="Enter Game ID" />
                                                </div>
                                                <div className="col-md-3">
                                                    <label className="form-label">Date Range</label>
                                                    <input type="text" className="form-control" placeholder="Feb 1 - Feb 28, 2026" />
                                                </div>
                                                <div className="col-md-2 d-flex align-items-end">
                                                    <button className="btn btn-primary w-100">Apply</button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Export buttons */}
                                        {/* Referee Fees Table */}
                                        <div className="card">
                                            <div className="card-body">
                                                <table className="table table-striped table-bordered" id="table2" ref={table2}>
                                                    <thead>
                                                        <tr>
                                                            <th>Game ID</th>
                                                            <th>Match Date</th>
                                                            <th>Referee Name</th>
                                                            <th>Referee Type</th>
                                                            <th>Fee Submitted</th>
                                                            <th>Fee Status</th>
                                                            <th>Game Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>GM-001</td>
                                                            <td>Feb 25, 2026</td>
                                                            <td>John Smith</td>
                                                            <td>Adult Referee</td>
                                                            <td>$150</td>
                                                            <td><span className="badge bg-soft-success">Released</span></td>
                                                            <td><span className="badge bg-soft-success">Completed</span></td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap">
                                                                    <li><a href="#" data-bs-toggle="modal" data-bs-target="#viewRefereeFeeModal"><i className="lni lni-eye" /></a></li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>GM-002</td>
                                                            <td>Feb 26, 2026</td>
                                                            <td>Sarah Johnson</td>
                                                            <td>Adult Referee</td>
                                                            <td>$150</td>
                                                            <td><span className="badge bg-soft-secondary">Held</span></td>
                                                            <td><span className="badge bg-soft-info">Scheduled</span></td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap">
                                                                    <li><a href="#" data-bs-toggle="modal" data-bs-target="#viewRefereeFeeModal"><i className="lni lni-eye" /></a></li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>GM-003</td>
                                                            <td>Feb 27, 2026</td>
                                                            <td>Mike Chen</td>
                                                            <td>Adult Referee</td>
                                                            <td>$150</td>
                                                            <td><span className="badge bg-soft-danger">Refunded</span></td>
                                                            <td><span className="badge bg-soft-danger">Cancelled</span></td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap">
                                                                    <li><a href="#" data-bs-toggle="modal" data-bs-target="#viewRefereeFeeModal"><i className="lni lni-eye" /></a></li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>GM-004</td>
                                                            <td>Feb 28, 2026</td>
                                                            <td>Jake Miller</td>
                                                            <td>Child Referee</td>
                                                            <td>$100</td>
                                                            <td><span className="badge bg-soft-secondary">Held</span></td>
                                                            <td><span className="badge bg-soft-info">Scheduled</span></td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap">
                                                                    <li><a href="#" data-bs-toggle="modal" data-bs-target="#viewRefereeFeeModal"><i className="lni lni-eye" /></a></li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>GM-005</td>
                                                            <td>Mar 1, 2026</td>
                                                            <td>Emily Davis</td>
                                                            <td>Adult Referee</td>
                                                            <td>$150</td>
                                                            <td><span className="badge bg-soft-success">Released</span></td>
                                                            <td><span className="badge bg-soft-success">Completed</span></td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap">
                                                                    <li><a href="#" data-bs-toggle="modal" data-bs-target="#viewRefereeFeeModal"><i className="lni lni-eye" /></a></li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>

            </div>
{showGameFeeModal && (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title fw-bold">Invoice Details</h5>
                    <button type="button" className="btn-close" onClick={closeGameFeeModal}></button>
                </div>
                <div className="modal-body p-4">
                    <div className="container-fluid">
                        {/* Row 1 */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="detail-label">Invoice ID</div>
                                <div className="detail-value">INV-003</div>
                            </div>
                            <div className="col-md-6">
                                <div className="detail-label">Game ID</div>
                                <div className="detail-value">GM-003</div>
                            </div>
                        </div>

                        {/* Row 2 */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="detail-label">Club Director</div>
                                <div className="detail-value">
                                    Michael Smith<br />
                                    <small className="text-secondary">michael.smith@wolvesfc.com</small><br />
                                    <small className="text-secondary">+1 234 567 8902</small>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="detail-label">Club & Team</div>
                                <div className="detail-value">
                                    Wolves FC · Wolves U-14
                                </div>
                            </div>
                        </div>

                        {/* Row 3 */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="detail-label">Season & Age Group</div>
                                <div className="detail-value">Spring 2026 · U-14</div>
                            </div>
                            <div className="col-md-6">
                                <div className="detail-label">Total Fee Amount</div>
                                <div className="detail-value">$600</div>
                            </div>
                        </div>

                        {/* Row 4 */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="detail-label">Due Date</div>
                                <div className="detail-value">Feb 18, 2026</div>
                            </div>
                            <div className="col-md-6">
                                <div className="detail-label">Payment Status</div>
                                <div className="detail-value">
                                    <span className="status-badge overdue">Overdue</span>
                                </div>
                            </div>
                        </div>

                        {/* Row 5 */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="detail-label">Payment Method</div>
                                <div className="detail-value">—</div>
                            </div>
                            <div className="col-md-6">
                                <div className="detail-label">Payment Date</div>
                                <div className="detail-value">—</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)}


        </>
    )
}

export default ClubManagement